import { SlotGameType1_21 } from '../SlotGameType1_21';

export class LavaLandMysticWarriorsFillingPot21 extends SlotGameType1_21
{
}
